<template>
  <section class="section">
    <card>
      <card-content>
        <h1 class="title">{{ $t('active_sessions.current_session') }}</h1>
        <table class="table is-fullwidth is-hoverable">
          <thead>
            <tr>
              <th>{{ $t('active_sessions.ip') }}</th>
              <th>{{ $t('active_sessions.current_session_logon_time') }}</th>
              <th>{{ $t('active_sessions.browser') }}</th>
              <th>{{ $t('active_sessions.platform') }}</th>
              <th>{{ $t('active_sessions.device') }}</th>
              <th>{{ $t('active_sessions.factors') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, idx) in lastLogins" :key="idx" :class="{'is-selected': idx === 0}">
              <td>{{ row.ip_addr }}</td>
              <td>{{ row.logged_in | date }}</td>
              <td>{{ row.browser }}</td>
              <td>{{ row.platform }}</td>
              <td>{{ row.device }}</td>
              <td>{{ row.factors }}</td>
            </tr>
          </tbody>
        </table>
        <br>
        <h1 class="title">{{ $t('active_sessions.all_sessions') }}</h1>
        <table class="table is-fullwidth is-hoverable">
          <thead>
            <tr>
              <th>{{ $t('active_sessions.ip') }}</th>
              <th>{{ $t('active_sessions.application') }}</th>
              <th>{{ $t('active_sessions.start') }}</th>
              <th>{{ $t('active_sessions.last_logon') }}</th>
              <th>{{ $t('active_sessions.browser') }}</th>
              <th>{{ $t('active_sessions.platform') }}</th>
              <th>{{ $t('active_sessions.device') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="ses in sessionApps" :key="ses.id">
              <td>{{ ses.ip_addr }}</td>
              <td>{{ ses.name }}</td>
              <td>{{ ses.created_at | date }}</td>
              <td>{{ ses.last_logon_at | date }}</td>
              <td>{{ ses.browser }}</td>
              <td>{{ ses.platform }}</td>
              <td>{{ ses.device_type }}</td>
            </tr>
          </tbody>
        </table>
      </card-content>
    </card>
  </section>
</template>
<script>
import profile from "@/services/profile";
import { Card, CardContent } from "@/components";
import {appSettings} from "@/app.settings";
export default {
  name: "SessionsList",
  components: {
    Card,
    CardContent
  },
  data() {
    return {
      sessionApps: [],
      lastLogins: []
    };
  },
  methods: {
    fetch() {
      profile.sessions().then(
        resp => {
          resp.data.forEach(e => {
            profile.getSessionApps(e.id).then(
              resp => {
                resp.data.forEach(a => this.sessionApps.push(a));
              },
              err => {
                console.log(err);
              }
            );
          });
        },
        err => {
          console.log(err);
        }
      );
    },
    fetchLastLogins() {
      const params = {
        sid: this.$store.getters.session_id,
        client_id: appSettings.clientId,
      };
      profile.getLastLogins(params).then((resp) => {
        this.lastLogins = resp.data;
      });
    },
  },
  filters: {
    date(value) {
      return new Date(value).toLocaleString();
    }
  },
  mounted() {
    this.fetch();
    this.fetchLastLogins();
  }
};
</script>
